const getHeaderValue = (headers: any, name: string): string | null => {
  if (!headers) return null;
  if (typeof headers.get === 'function') {
    return headers.get(name) || headers.get(name.toLowerCase()) || null;
  }
  return headers[name] || headers[name.toLowerCase()] || null;
};

const getResponseMessage = (data: unknown): string | null => {
  if (typeof data === 'string') return data.trim() || null;
  if (!data || typeof data !== 'object') return null;

  const payload = data as Record<string, unknown>;
  for (const key of ['message', 'error', 'detail', 'title']) {
    const value = payload[key];
    if (typeof value === 'string' && value.trim()) return value;
  }

  return null;
};

export const getApiErrorMessage = (err: any, defaultMessage: string): string => {
  const status = err?.response?.status ?? err?.status;
  const headers = err?.response?.headers;
  const headerMessage =
    getHeaderValue(headers, 'X-Error-Message') ||
    getHeaderValue(headers, 'X-Lock-Reason') ||
    getHeaderValue(headers, 'X-Conflict-Reason') ||
    getHeaderValue(headers, 'X-Blocked-Reason');
  const responseMessage = getResponseMessage(err?.response?.data);

  if (headerMessage) return headerMessage;
  if (responseMessage) return responseMessage;
  if (status === 403) return 'Accesso negato: non hai i permessi per questa operazione';
  if (typeof err?.message === 'string' && err.message.trim() && !err?.response) {
    return err.message;
  }
  return defaultMessage;
};
